import { render, staticRenderFns } from "./UpgradeButton.vue?vue&type=template&id=07fb4a88&"
import script from "./UpgradeButton.vue?vue&type=script&lang=ts&"
export * from "./UpgradeButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports